/**
 * After a form submission is rejected by client-side validation, moves focus to the first field
 * marked `aria-invalid` so keyboard and screen-reader users land on the problem instead of staying
 * on the submit button. Runs after React has committed the error state of the submit handler.
 */
export function installFocusFirstInvalid(target: Document = document): () => void {
  const onSubmit = (event: Event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    window.setTimeout(() => {
      const invalid = form.querySelector<HTMLElement>('[aria-invalid="true"]');
      if (invalid === null || !invalid.isConnected) return;
      invalid.focus();
    }, 0);
  };
  // Capture phase: dialogs stop submit propagation so it does not reach a parent form.
  target.addEventListener('submit', onSubmit, true);
  return () => {
    target.removeEventListener('submit', onSubmit, true);
  };
}
